import { Box, IconArrowRight16, Stack, Text } from '@stitch-fix/mode-react';
import { Link } from '@stitch-fix/sf-next';
import { PromoCodeInputField } from './PromoCodeInputField';
export const PromoCodeInput = () => {
  return <Stack bgColor="gray-99" p={1.25} maxWidth="550px" spacing={1}>
      <Text setting="subtitle-medium">Redeem your promo code.</Text>
      <PromoCodeInputField />
      <Box>
        <Link size="tertiary" href="/gifts" endIcon={<IconArrowRight16 />}>
          Or, redeem a gift code
        </Link>
      </Box>
    </Stack>;
};